/**
 * TagDetailContainer
 * --
 */
import { useMemo } from 'react';
import { useGetTags } from 'hooks/TagHooks';
import { useGetShopInformations } from 'hooks/ShopInformationHooks';
import { useGetProductCategories } from 'hooks/ProductCategoryHooks';
import TagDetailPresenter from './TagDetailPresenter';

const TagDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const response = useGetTags();
  const { data: shopInformationList } = useGetShopInformations({
    application_status: 'APPROVE',
  });
  const { data: productCategoryList } = useGetProductCategories({
    application_status: 'APPROVE',
    type: 'PRODUCT',
  });
  const tagList = useMemo(() => {
    if (response && response.data) {
      const { data } = response.data;
      return data.map((tag) => {
        return {
          key: tag.tag_id,
          ...tag,
          products: tag?.products?.map((product) => {
            const shop_information = shopInformationList?.data?.find(
              (shop) =>
                shop?.shop_information_id === product?.shop_information_id
            );
            const product_category = productCategoryList?.data?.find(
              (category) =>
                category?.product_category_id === product?.product_category_id
            );
            return {
              ...product,
              product_category: product_category,
              shop_information: shop_information,
            };
          }),
        };
      });
    }

    return [];
  }, [response]);
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <TagDetailPresenter tagList={tagList} />
    </>
  );
};

export default TagDetailContainer;
